import { resourceFormConfigQuery } from "src/system/resourceFormConfigQuery.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { FieldValues } from "react-hook-form";
import type { ValidParams } from "src/lib/react-router/types.ts";
import type {
  ValidFormData,
  ValidRequestData,
} from "src/components/Form/hooks/useResourceForm/useResourceForm.tsx";

export const useResourceFormConfig = <
  FormValues extends FieldValues = FieldValues,
  Params extends ValidParams = ValidParams,
  FormData extends ValidFormData = ValidFormData,
  RequestData extends ValidRequestData = ValidRequestData,
>({
  resource,
  action,
  tab,
}: {
  resource: string;
  action: "create" | "edit";
  tab?: string;
}) => {
  const { data: formConfig, refetch: refetchFormConfig } = useSuspenseQuery(
    resourceFormConfigQuery<FormValues, Params, FormData, RequestData>({
      resource,
      action,
      tab,
    }),
  );

  return {
    formConfig,
    refetchFormConfig,
  };
};
